// Imports for external libraries go here.
import React, { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { OffersMultiplierProps } from './OffersMultiplier.types';
import { StyledOffersMultiplier } from './OffersMultiplier.styles';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { OffersMultiplierWrapper } from './OffersMultiplierWrapper';

export const OffersMultiplierWrapperConfig = {
  emptyLabel: 'Offers Multiplier',
  isEmpty: () => true,
  resourceType: `mi-aem-offers-spa/components/offersmultiplier`,
};

export const OfferMultiplierwWrapper: React.FC<OffersMultiplierProps> = props => {
  return <OffersMultiplierWrapper {...props} />;
};

// Use named rather than default exports.
export const OffersMultiplier: FC<OffersMultiplierProps> = props => {
  const isNonEditable = props.cqPath?.includes('experiencefragment');

  const offersMultiplierWrapper = (
    <StyledOffersMultiplier data-testid="offers-OffersMultiplier" data-component-name="o-offers-OffersMultiplier">
      <OfferMultiplierwWrapper {...props} />
    </StyledOffersMultiplier>
  );

  return isNonEditable ? (
    offersMultiplierWrapper
  ) : (
    <EditableComponent config={OffersMultiplierWrapperConfig} {...props}>
      {offersMultiplierWrapper}
    </EditableComponent>
  );
};
